import React from 'react';
import { useAuth } from '../../AuthContext';
import { toast } from 'react-toastify';

// Shared logic hook for YouTube
export const useYouTubeAuth = () => {
    const myContext = useAuth();

    const launchYouTube = (accountId = null) => {
        const CLIENT_ID = "574687813830-ub7998rioobcrcqqhkklo1hp0e1jthqn.apps.googleusercontent.com";
        const REDIRECT_URI = encodeURIComponent("https://schedpilot.com/wp-json/api/v1/callbackYoutube");
         const SCOPE = encodeURIComponent(
                "https://www.googleapis.com/auth/youtube.upload " +

                "https://www.googleapis.com/auth/yt-analytics.readonly " +
                "openid email profile"
            );


            /*const SCOPE = encodeURIComponent(
                "https://www.googleapis.com/auth/youtube.upload " + 
                "https://www.googleapis.com/auth/yt-analytics.readonly " + 
                "openid email profile"
            ); */
        
        // Include accountId in the state so your backend can identify the specific record
        const stateObj = {
            nonce: Math.random().toString(36).substring(7),
            accountId: accountId 
        };
        const state = encodeURIComponent(JSON.stringify(stateObj));

        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${CLIENT_ID}&` +
            `redirect_uri=${REDIRECT_URI}&` +
            `response_type=code&` +
            `scope=${SCOPE}&` +
            `access_type=offline&` +
            `prompt=consent&` +
            `state=${state}`;

        const width = 800, height = 600;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const authWindow = window.open(
            authUrl,
            'YouTube Auth',
            `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes, resizable=yes`
        );

        const handleMessage = (event) => {
            if (event.data.type === "youtube-finished-verification") {
                const { access_token, refresh_token, id_token } = event.data;

                // Fall back to localStorage: the context copy is populated
                // asynchronously on load, so it can still be null here for a
                // session restored from the auth cookie. Sending an empty JWT
                // made the save fail with no visible error at all.
                const jwtToken2 = myContext.jwtToken || localStorage.getItem('jwtToken') || '';

                window.removeEventListener("message", handleMessage);

                if (!jwtToken2) {
                    toast.error('Your session has expired. Please sign in again, then reconnect YouTube.');
                    return;
                }

                if (!access_token) {
                    toast.error('Google did not return an access token. Please try connecting again.');
                    return;
                }

                // Pass the accountId to your token exchange endpoint
                const url = `https://api.schedpilot.com/wp-json/api/v1/token-exchange-youtube/`
                    + `?access_token=${encodeURIComponent(access_token)}`
                    + `&refresh_token=${encodeURIComponent(refresh_token || '')}`
                    + `&id_token=${encodeURIComponent(id_token || '')}`
                    + `&jwtToken=${encodeURIComponent(jwtToken2)}`
                    + `&accountId=${encodeURIComponent(accountId || '')}`;

                fetch(url, { method: 'GET' })
                    .then(async (res) => {
                        // This used to be `.then(() => …)`, so an expired session
                        // or a failed DB write looked exactly like success: the
                        // list refreshed, the window closed, no account appeared
                        // and nothing was reported.
                        const json = await res.json().catch(() => null);
                        const failed = !res.ok || json?.success === false;

                        if (failed) {
                            const msg = json?.data?.message
                                || `Could not connect your YouTube account (error ${res.status}).`;
                            console.error('YouTube token exchange failed:', res.status, json);
                            toast.error(msg);
                            return;
                        }

                        myContext.getAccountsData();
                        toast.success('YouTube account connected.');
                        if (authWindow && !authWindow.closed) authWindow.close();
                    })
                    .catch(error => {
                        console.error('YouTube Token exchange failed:', error);
                        toast.error('Network error while connecting YouTube. Please try again.');
                    });
            }
        };

        window.addEventListener("message", handleMessage);
    };

    return { launchYouTube };
};

// --- The Buttons ---

export function YouTubeConnectButton() {
    const { launchYouTube } = useYouTubeAuth();
    return (
        <button className='btn btn-primary' onClick={() => launchYouTube(null)}>
            Connect Youtube
        </button>
    );
}

export function YouTubeReconnectButton({ accountId }) {
    const { launchYouTube } = useYouTubeAuth();
    return (
        <button className='btn btn-sm mr-1 btn-warning' onClick={() => launchYouTube(accountId)}>
            Reconnect Youtube
        </button>
    );
}